import type { CheckoutFormState } from "@/pages/Checkout/checkout-form.types";
import type { IItemVersion } from "@/common/types/item.types";
import type { CreateOrderRequest } from "./orders.types";

const AMAZONIAN_ORDER_LABEL = "AMAZONIAN";

export const buildCreateOrderRequest = (
  form: CheckoutFormState,
  selectedVersion: IItemVersion,
  username: string,
  isDeviceReturnRequired: boolean
): CreateOrderRequest => {
  const now = new Date();
  const ack = (policyName: string, acknowledged: boolean) => ({
    by: username,
    on: now,
    policyName,
    acknowledged,
  });

  return {
    items: {
      [selectedVersion.taxonomyId]: {
        quantity: 1,
        details: isDeviceReturnRequired
          ? { returnedDeviceSerialNumber: form.serialNumberForReturnDevice }
          : undefined,
      },
    },
    deliveryTo: {
      fullName: form.fullName,
      country: form.country,
      countryISO3: form.countryISO3,
      addressLine1: form.addressLine1,
      addressLine2: form.addressLine2,
      addressLine3: form.addressLine3,
      city: form.city,
      citySubdivision1: form.citySubdivision1,
      county: form.county,
      postalCode: form.postalCode,
      countryCode: form.countryCode,
      phoneNumber: form.phoneNumber,
      deliveryInstructions: form.deliveryInstructions,
    },
    details: {
      checkoutInfo: {
        costCenter: form.costCenter,
        carCode: form.carCode,
        businessJustification: form.businessJustification,
      },
      deliverTo: {
        country: form.countryISO3,
      },
    },
    acknowledgementAudit: [
      ack("Shipping details are accurate confirmation", form.shippingDetailsConfirmationCheckbox),
      ack(
        "Manager is aware and information is accurate confirmation",
        form.managerConfirmationCheckbox
      ),
      ack("Hardware Ownership Policy", form.policyConfirmationCheckbox),
      ack("It Services Hardware Policy", form.policyConfirmationCheckbox),
    ],
    labels: [AMAZONIAN_ORDER_LABEL],
  };
};
